/*
  Faixa de videos de cliente (Match Day).

  Tres trabalhos, todos herdados do comportamento medido na referencia:

  1) O arquivo do video so e baixado quando o cartao chega perto da tela. Sao dezenas de
     megabytes se todos carregarem juntos, e a faixa fica no fim da pagina de produto -
     a maioria dos visitantes nunca rola ate la.
  2) Toca sozinho, mudo, enquanto esta visivel; pausa ao sair. Video mudo com playsinline
     e o unico formato que o iOS deixa tocar sem gesto do usuario.
  3) O botao de som liga o audio de UM video e cala os outros - dois audios ao mesmo
     tempo e o defeito obvio de uma faixa dessas.

  Quem pediu menos movimento no sistema nao recebe reproducao automatica: o video fica
  na capa e so toca se a pessoa apertar o som.
*/
(function () {
  'use strict';

  if (window.__mdVideosClientesInit) return;
  window.__mdVideosClientesInit = true;

  var CALMO = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function todos() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-md-video]'));
  }

  function carregar(video) {
    if (video.dataset.mdCarregado) return;
    var fonte = video.getAttribute('data-src');
    if (!fonte) return;
    video.dataset.mdCarregado = '1';
    video.src = fonte;
    video.load();
  }

  /*
    DESTRAVA NO TOQUE (06/09/2026), mesmo tratamento do video da galeria da PDP.

    Quando o navegador recusa o play automatico - no iPhone o caso mais comum e o Modo
    de Pouca Energia, que bloqueia autoplay de video - o cartao ficava parado no primeiro
    quadro. Agora o primeiro toque no video liga, porque gesto do usuario e sempre
    aceito. Nao muda nada na tela e nao conflita com o botao de som, que e irmao do
    video, nao filho.
  */
  /*
    O BOTAO DE PLAY (06/09/2026) so nasce quando o autoplay foi RECUSADO - confirmado
    pelo Ivan no iPhone: com Modo de Pouca Energia ligado o video nao toca sozinho, com
    o modo desligado toca normal. Com autoplay liberado nada disto roda: nem o <style>,
    nem o botao, nem o ouvinte de toque. A tela fica exatamente como esta hoje.

    Mora no pai direto do video, que ja e position: relative nos dois componentes
    (.product__media na galeria, .md-videos__midia nos videos de clientes), entao nao
    mexe em layout nenhum. Some sozinho no evento "playing", inclusive quando o video
    volta a tocar por conta propria, e reaparece se um play posterior for recusado de
    novo. O stopPropagation evita que o toque no botao vire clique no cartao em volta.
  */
  var CSS_BOTAO =
    '.md-play-travado.md-play-travado{position:absolute!important;top:50%!important;left:50%!important;right:auto!important;bottom:auto!important;transform:translate(-50%,-50%)!important;z-index:2!important;display:flex!important;align-items:center;justify-content:center;box-sizing:border-box!important;width:64px!important;height:64px!important;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;padding:0!important;margin:0!important;border:0!important;border-radius:50%!important;background:rgba(17,17,17,0.55)!important;color:#fff;cursor:pointer;object-fit:none!important}.md-play-travado.md-play-travado svg{width:28px!important;height:28px!important;margin-left:3px!important;position:static!important}.md-play-travado.md-play-travado[hidden]{display:none!important}';

  function estiloDoBotao() {
    if (document.getElementById('md-play-travado-estilo')) return;
    var e = document.createElement('style');
    e.id = 'md-play-travado-estilo';
    e.textContent = CSS_BOTAO;
    document.head.appendChild(e);
  }

  function tentarTocar(video) {
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function botaoDePlay(video) {
    var pai = video.parentElement;
    var botao = pai.querySelector('.md-play-travado');
    if (botao) return botao;
    estiloDoBotao();
    botao = document.createElement('button');
    botao.type = 'button';
    botao.className = 'md-play-travado';
    botao.setAttribute('aria-label', 'Play video');
    botao.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z" fill="currentColor"></path></svg>';
    botao.addEventListener('click', function (evento) {
      evento.stopPropagation();
      tentarTocar(video);
    });
    video.addEventListener('playing', function () {
      botao.hidden = true;
    });
    pai.appendChild(botao);
    return botao;
  }

  function destravarNoToque(video) {
    botaoDePlay(video).hidden = false;
    if (video.dataset.mdToquePraTocar) return;
    video.dataset.mdToquePraTocar = '1';
    video.addEventListener('click', function () { tentarTocar(video); });
  }

  function tocar(video) {
    if (CALMO && video.muted) return;
    var p = video.play();
    /* navegador pode recusar o play (aba em segundo plano, economia de bateria);
       sem o catch isso vira erro nao tratado no console */
    if (p && typeof p.catch === 'function') p.catch(function () { destravarNoToque(video); });
  }

  function silenciarOutros(atual) {
    todos().forEach(function (v) {
      if (v === atual) return;
      if (!v.muted) {
        v.muted = true;
        var botao = v.parentElement.querySelector('[data-md-som]');
        if (botao) botao.setAttribute('aria-pressed', 'false');
      }
    });
  }

  function iniciar(video) {
    if (video.dataset.mdPronto) return;
    video.dataset.mdPronto = '1';

    video.addEventListener('loadeddata', function () {
      video.classList.add('esta-pronto');
    });

    var botao = video.parentElement.querySelector('[data-md-som]');
    if (botao) {
      botao.addEventListener('click', function () {
        var ligando = video.muted;
        if (ligando) {
          carregar(video);
          silenciarOutros(video);
          video.muted = false;
          tocar(video);
        } else {
          video.muted = true;
        }
        botao.setAttribute('aria-pressed', ligando ? 'true' : 'false');
      });
    }
  }

  function observar() {
    var lista = todos();
    if (!lista.length) return;
    lista.forEach(iniciar);

    if (!('IntersectionObserver' in window)) {
      /* navegador antigo: carrega tudo e deixa parado na capa */
      lista.forEach(carregar);
      return;
    }

    /* margem generosa: o arquivo comeca a baixar antes de o cartao aparecer, senao o
       primeiro quadro so pinta depois que a pessoa ja esta olhando pro retangulo preto */
    var pre = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            carregar(e.target);
            pre.unobserve(e.target);
          }
        });
      },
      { rootMargin: '600px 200px' }
    );

    var play = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            carregar(v);
            tocar(v);
          } else {
            v.pause();
            /* saiu da tela com som ligado: devolve pro mudo pra nao voltar gritando */
            if (!v.muted) {
              v.muted = true;
              var b = v.parentElement.querySelector('[data-md-som]');
              if (b) b.setAttribute('aria-pressed', 'false');
            }
          }
        });
      },
      { threshold: 0.5 }
    );

    lista.forEach(function (v) {
      pre.observe(v);
      play.observe(v);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observar);
  } else {
    observar();
  }

  /* o editor de tema recria a section inteira a cada mudanca de campo */
  document.addEventListener('shopify:section:load', observar);
})();
